import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useListingShareButtonClicked = listingId => {
  const dispatch = useDispatch()
  const [shareButtonClicked, setShareButtonClicked] = useState(false)

  const shareButtonClickedState = useSelector(
    state => state.listing[listingId]?.share_listing_button_clicked
  )

  useEffect(() => {
    setShareButtonClicked(shareButtonClickedState === '1' || shareButtonClickedState === 1)
  }, [shareButtonClickedState])

  useEffect(() => {
    const fetchData = async () => {
      if (shareButtonClicked) return
      await dispatch.listing.getShareListingButtonClicked({ listingId })
    }
    fetchData()
  }, [dispatch.listing, shareButtonClicked, listingId])

  return shareButtonClicked
}
